import { Api } from '@/services/Api'
import axios from 'axios'
import store from "@/store/index"
const momentTz = require('moment-timezone')

export default {
  fetchTemplate(plantId, plantName) {
    Api().request({
      url: `/api/v2/zmu/admin/fetch/${plantId}`,
      method: 'GET',
      responseType: 'blob'
    }).then((response) => {
      const tz = store.getters.getGeneralState('activePlant').timezone
      const filename = `${plantName}_multiplication_factor-${momentTz().tz(tz).format('YYYY_MM_DD_HH_mm_ss')}.xlsx`
      const url = window.URL.createObjectURL(new Blob([response.data]))
      const link = document.createElement('a')
      link.href = url
      link.setAttribute('download', filename)
      document.body.appendChild(link)
      link.click()
      document.body.removeChild(link)
      window.URL.revokeObjectURL(url)
    })
  },
  zmuCacheRefresh(reset) {
    return axios.post('https://m2m.eaglesunscada.com/api/v1.0/pushzmu/resetzmuconfig', reset)
  }
}
